import type { Bonus, FAQItem } from '../types/content'

export const withoutItems: string[] = [
  '😓 Ripetere gli stessi schemi senza sapere perché',
  '🔁 Risorse disperse che mancano di struttura',
  '💭 Mancare di chiarezza su certi schemi ricorrenti',
  '😰 Trasmettere le stesse ferite ai tuoi figli',
  '🌙 Vivere tutta la vita nella storia di qualcun altro',
]

export const withItems: string[] = [
  '📖 Esplora la tua mappa familiare',
  '🎯 Riconosci gli schemi ricorrenti e le loro possibili origini',
  '🧩 Utilizza frasi, esercizi e strumenti pratici di riflessione',
  '🌳 Osserva il tuo sistema familiare da una nuova prospettiva',
  '📅 Costruisci nuovi punti di riferimento attraverso un percorso strutturato',
]

export const bonuses: Bonus[] = [
  {
    label: 'Bonus 01',
    title: 'Le Carte di Frasi di Guarigione',
    subtitle: '50 Carte Stampabili Premium Pronte all’Uso',
    image: 'https://cdn.magicpatterns.com/uploads/bPhLY7aQMFKdeJiTE9wXsi/bonus_01_costellazioni_italiano_optimizzato.jpg',
  },
  {
    label: 'Bonus 02',
    title: 'I Genogrammi Professionali Clinici',
    subtitle: '40 Modelli A4 Pronti all’Uso',
    image: 'https://cdn.magicpatterns.com/uploads/hBGarZ88WTYBmG9rmeMj1p/ChatGPT_Image_3_sept_2026,_01_17_55_p.m..png',
  },
  {
    label: 'Bonus 03',
    title: 'Gli Esercizi Pratici di Integrazione Sistemica',
    subtitle: '60 Protocolli Illustrati Passo-Passo',
    image: 'https://cdn.magicpatterns.com/uploads/ptiToYcKGJ75m4Va7zGzsH/ChatGPT_Image_3_sept_2026,_01_18_01_p.m..png',
  },
  {
    label: 'Bonus 04',
    title: 'La Meditazione Guidata Transgenerazionale',
    subtitle: '5 Sessioni Audio MP3 + Trascrizioni Complete',
    image: 'https://cdn.magicpatterns.com/uploads/nHhCz4k3rm8Ftq9s5RMVoS/ChatGPT_Image_3_sept_2026,_01_18_21_p.m..png',
  },
  {
    label: 'Bonus 05',
    title: 'Il Diario di Integrazione Sistemica',
    subtitle: 'Workbook Strutturato di 90 Giorni',
    image: 'https://cdn.magicpatterns.com/uploads/vEQtczMzY968s5ZCahP7ce/ChatGPT_Image_3_sept_2026,_01_18_27_p.m..png',
  },
]

export const offerSummary: string[] = [
  '6 Tomi Premium Illustrati',
  '5 Bonus Premium',
  '300+ Pagine di Contenuto',
  '50 Carte di Frasi di Guarigione',
  '40 Modelli di Genogramma',
  '60 Esercizi Pratici Illustrati',
  '5 Meditazioni Guidate MP3',
  'Diario di Integrazione di 90 Giorni',
  'Risorse Stampabili A4',
  'Accesso a Vita',
  'Download Immediato',
]

export const checkoutUrl = 'https://costellazioni-familiari.impultienda.ar/checkout'

export const trustLine = '🔒 Pagamento Sicuro · ⚡ Download Immediato · 🛡️ Garanzia 7 Giorni · 💳 Pagamento con Carta · ♾️ Accesso a Vita'

export const costs: [string, string][] = [
  [
    '🔁 Schemi in Ciclo',
    'Certi schemi possono sembrare ripetersi nelle relazioni e in diverse fasi della vita, senza che la loro origine sia sempre chiara.',
  ],
  [
    '💸 Terapia Senza Radici',
    'Le risorse disperse possono rendere difficile la comprensione complessiva della tua storia familiare. Questo sistema riunisce gli strumenti in una collezione strutturata e accessibile.',
  ],
  [
    '👶 L’Eredità che Lasci',
    'Senza riconoscere il ciclo, gli schemi non esplorati possono restare parte di ciò che si trasmette. Rimandare questa comprensione ha un peso generazionale.',
  ],
  [
    '⏱️ Il Tempo Già Perso',
    'Ogni anno senza una struttura chiara è un altro anno in cui certi schemi restano difficili da leggere. La mappa esiste. L’unica domanda è quando scegli di leggerla.',
  ],
]

export const faqs: FAQItem[] = [
  {
    question: 'Come funziona il sistema ?',
    answer:
      'Il sistema è strutturato in 6 Tomi che coprono tutti gli aspetti del lavoro sistemico. Ogni tomo affronta una ferita o un blocco specifico. Leggi il tomo che corrisponde al tuo bisogno immediato, usa gli esercizi pratici inclusi, applica le frasi di guarigione, compila i genogrammi, ascolta le meditazioni. Il Diario di 90 Giorni guida la tua integrazione giorno per giorno.',
  },
  {
    question: 'Ho bisogno di conoscenze precedenti ?',
    answer:
      'No. Ogni tomo è autoesplicativo e costruito per i principianti assoluti. Se sei nuovo alle costellazioni familiari, inizia dal Tomo I. Se hai esperienza, salta direttamente ai tomi che affrontano le tue ferite specifiche.',
  },
  {
    question: 'Le risorse sono davvero stampabili ?',
    answer:
      'Sì. Tutte le carte di guarigione, i genogrammi e gli schemi sono in formato PDF stampabile ad alta risoluzione. Puoi stamparli come desideri — carta normale, cardstock, formato A4 o personalizzato. Molte persone laminano le carte e le usano quotidianamente.',
  },
  {
    question: 'I 5 Bonus sono davvero gratuiti ?',
    answer:
      'Sì. I 5 bonus sono completamente inclusi senza costi aggiuntivi durante questo lancio. Ricevi : 50 Carte di Frasi di Guarigione, 40 Genogrammi Clinici, 60 Esercizi Pratici, 5 Meditazioni MP3 e il Diario di Integrazione di 90 Giorni — tutto gratuitamente.',
  },
  {
    question: 'Quanto tempo ho accesso al contenuto ?',
    answer:
      'Accesso a vita. Una volta acquistato, scarichi tutto e rimane tuo per sempre. Nessun abbonamento. Nessun accesso condizionato. È tuo.',
  },
  {
    question: 'Cosa rende questo sistema diverso dalle risorse gratuite online ?',
    answer:
      'Questo sistema è strutturato, professionalmente illustrato e completamente integrato. Non è una raccolta di articoli. È un percorso completo costruito su 25+ anni di ricerca in costellazioni familiari. Ogni elemento è stato selezionato e ordinato per accompagnare la tua comprensione passo dopo passo.',
  },
  {
    question: 'E se questo non funziona per me ?',
    answer:
      'Garanzia di rimborso completa 7 giorni. Se il sistema non corrisponde alle tue aspettative, richiedi un rimborso. Nessuna domanda. Nessun modulo. Nessun problema. Il rischio è completamente nostro.',
  },
]
